import { SystemUserLogin, SystemUserVerify, SystemUserModify, SystemUserInsert, SystemUserDelete, SystemUserUpdate, SystemUserGetById, SystemUserGetList, SystemUserGetPageList } from "@/api/systemuser/index.js";



const state = {
    userInfo: {
        userId: null
    }
}

const getters = {

}

const mutations = {
    SET_USERINFO(state, payload) {
        let { userId } = payload
        localStorage.setItem('userId', userId)
        state.userInfo = { userId: userId }
    }
}

const actions = {
    // 登录
    SystemUserLogin(context, payload) {
        return new Promise((resolve, reject) => {
            SystemUserLogin({ ...payload }).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 验证
    SystemUserVerify(context, payload) {
        return new Promise((resolve, reject) => {
            SystemUserVerify({ ...payload }).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 修改
    SystemUserModify(context, payload) {
        return new Promise((resolve, reject) => {
            SystemUserModify({ ...payload }).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 新增
    SystemUserInsert(context, payload) {
        return new Promise((resolve, reject) => {
            SystemUserInsert({ ...payload }).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 更新
    SystemUserUpdate(context, payload) {
        let { id } = payload
        return new Promise((resolve, reject) => {
            SystemUserUpdate(id, { ...payload }).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取
    SystemUserGetById(context, payload) {
        let { id } = payload
        return new Promise((resolve, reject) => {
            SystemUserGetById(id).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取列表
    SystemUserGetList(context, payload) {

        return new Promise((resolve, reject) => {
            let params = { ...payload }
            SystemUserGetList(params).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取分页列表
    SystemUserGetPageList(context, payload) {
        return new Promise((resolve, reject) => {
            let params = { ...payload }
            SystemUserGetPageList(params).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}